// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3itTp","clinicsSelect":"TableHeading_clinicsSelect__1tMmU"};